module.exports = __webpack_public_path__ + "static/media/tip-2.55616b45.mp3";